/**
 * LE RAPPORT PDF N'EST PROPOSÉ QUE S'IL EXISTE (D24 du 05/10/2026, maquette
 * mq-rapport).
 *
 * Le moteur refuse le rapport d'une étude encore en calcul ou terminée sans
 * résultat (409 `optimturpe-rapport-etude-en-cours` et
 * `optimturpe-rapport-etude-sans-resultat`). La page ne propose donc ni
 * « Télécharger le rapport PDF » ni « Aperçu » avant qu'un résultat soit servi,
 * et ne les grise pas non plus : un bouton grisé promet une action qui
 * n'existe pas (F8.1). Une fois le résultat servi, les deux boutons sont dans
 * l'en-tête du temps 3, visibles sans rien déplier.
 */
import type { OptimTurpeV2Etude } from "@modules/courtage/types/optim-turpe-v2"

/** Ce que la page sait, à côté de l'étude, au moment de proposer le rapport. */
export interface EtatRapport {
    /** Le drapeau `RAPPORT_PDF_V2_ACTIF`. */
    actif: boolean
    /** Une erreur de lancement est à l'écran (F7.16). */
    erreur: boolean
    /** L'étude affichée porte un échec nommé. */
    echec: boolean
    /** Le dernier lancement a été refusé. */
    refus: boolean
}

/**
 * Vrai seulement pour une étude identifiée, terminée sur un résultat
 * (`status` « SUCCESS »), sans échec, refus ni erreur à l'écran.
 */
export function rapportProposable(
    etude: OptimTurpeV2Etude | null | undefined,
    etat: EtatRapport
): boolean {
    if (!etat.actif || etat.erreur || etat.echec || etat.refus) return false
    return Boolean(etude?._id) && etude?.status === "SUCCESS"
}
